import React, { useEffect, useRef } from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { PatientExperience } from '../components/PatientExperience';
import { ProviderNetwork } from '../components/ProviderNetwork';
import { Testimonials } from '../components/Testimonials';
import { InvestorSection } from '../components/InvestorSection';
export function Home() {
  const containerRef = useRef(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleMouseMove = e => {
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;
      container.style.setProperty('--mouse-x', x);
      container.style.setProperty('--mouse-y', y);
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  return <div ref={containerRef} className="min-h-screen relative" style={{
    backgroundImage: 'radial-gradient(circle at calc(var(--mouse-x, 0.5) * 100%) calc(var(--mouse-y, 0.5) * 100%), rgba(187, 221, 255, 0.35), transparent 50%)',
    backgroundSize: '120% 120%',
    backgroundPosition: 'center'
  }} data-id="element-397">
      <Hero data-id="element-398" />
      <Features data-id="element-399" />
      <PatientExperience data-id="element-400" />
      <ProviderNetwork data-id="element-401" />
      <Testimonials data-id="element-402" />
      <InvestorSection data-id="element-403" />
    </div>;
}